import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { FollowupRecordPage } from '@/features/medication-followups/followup-record-page'

/** Record what happened to the dose of a follow-up, on its own page (Phase 2 Task 6a). */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-followups/$occurrenceId/record'
)({
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: FollowupRecordPage,
})
